import ModalBlocked from "../../../components/modal/modal-blocked";
import AjaxForm from "../../../components/ajax-form";
import { initLoader } from "../../../services/init-loader-button";
import Toast from "../../../components/modal/toast";



const initRespondForm = (form, onSubmit) => {
  new AjaxForm(form, {
    afterSubmit: () => {
      onSubmit();
      Toast.open('Ваш отклик отправлен работодателю', {
        state: "success"
      });
    }
  });

  return {
    reset: () => form.reset(),
  };
}

const vacancyResponseInit = () => {
  let respondButton = document.querySelector('[data-respond-vacancy]');
  if (!respondButton) return;

  let respondPopupElement = document.getElementById('vacancy-respond');
  if (!respondPopupElement) return;

  let respondFormElement = respondPopupElement.querySelector('.vacancy-respond-form');
  if (!respondFormElement) return;

  initLoader(respondFormElement);

  let respondPopup = ModalBlocked.get(respondPopupElement);
  let respondForm = initRespondForm(respondFormElement, () => respondPopup.close());

  respondButton.addEventListener('click', () => {
    respondForm.reset();
    respondPopup.open();
  });
};

export { vacancyResponseInit };